/**
 * iurop-press.js — rotador de citas de la sección de prensa Laganini.
 *
 * Alterna [data-lg-press-quote] dentro de [data-lg-press] con dots
 * ([data-lg-press-dot]). Autoplay 5s solo con más de una cita; se pausa con
 * la pestaña oculta y con prefers-reduced-motion. Re-init en
 * shopify:section:load.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var INTERVAL = 5000;

  function init(root) {
    if (root.__lgPressInit) return;
    root.__lgPressInit = true;

    var quotes = Array.prototype.slice.call(
      root.querySelectorAll('[data-lg-press-quote]')
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-lg-press-dot]')
    );
    if (quotes.length < 2) return;

    var current = 0;
    var timer = null;

    function show(index) {
      quotes[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + quotes.length) % quotes.length;
      quotes[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function start() {
      if (timer || reduced.matches) return;
      timer = window.setInterval(function () {
        show(current + 1);
      }, INTERVAL);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        show(parseInt(dot.getAttribute('data-index'), 10) || 0);
        start();
      });
    });

    // ---- Swipe con el dedo -------------------------------------------------
    // Las citas se alternan por CSS (no hay pista que arrastrar), asi que basta
    // con detectar el gesto y saltar a la anterior/siguiente. Solo touch/pen:
    // con raton estorbaria a la seleccion de texto de la cita.
    // El eje se decide a los 8px; si es vertical no tocamos nada y la pagina
    // scrollea normal (el contenedor lleva touch-action: pan-y).
    var swipeArea = root.querySelector('.laganini-press__quotes') || root;
    var startX = 0;
    var startY = 0;
    var axis = '';
    var tracking = false;
    var THRESHOLD = 40;

    swipeArea.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse') return;
        tracking = true;
        axis = '';
        startX = e.clientX;
        startY = e.clientY;
      },
      { passive: true }
    );

    swipeArea.addEventListener('pointermove', function (e) {
      if (!tracking) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!axis && Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      if (!axis) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (axis === 'y') {
        tracking = false;
        return;
      }
      if (e.cancelable) e.preventDefault();
    });

    function endSwipe(e) {
      if (!tracking) return;
      tracking = false;
      if (axis !== 'x') return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) < THRESHOLD) return;
      stop();
      show(current + (dx < 0 ? 1 : -1));
      start();
    }

    swipeArea.addEventListener('pointerup', endSwipe, { passive: true });
    swipeArea.addEventListener('pointercancel', function () {
      tracking = false;
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lg-press]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
